module.exports = __webpack_public_path__ + "img/mobile-elbow-1_80x70.edd7aaae.png";